import { render, staticRenderFns } from "./swProduct.vue?vue&type=template&id=1a516490&scoped=true&"
import script from "./swProduct.vue?vue&type=script&lang=js&"
export * from "./swProduct.vue?vue&type=script&lang=js&"
import style0 from "./swProduct.vue?vue&type=style&index=0&id=1a516490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a516490",
  null
  
)

export default component.exports